import React, { useEffect } from "react";
import AppForms from "@toothfairy/shared-ui/AppForms";
import { isLargeScreen } from "../../../../MainViewContainer";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import Constants from "../../../../../Constants";
import { AppText, AppIcon } from "@toothfairy/shared-ui";
import { View, TouchableOpacity } from "react-native";
import AppAssets from "@toothfairy/shared-ui/AppAssets";

const QaHiringResourcesInstancesLeaf = ({
  u,
  onTick = () => {},
  isTicked = true,
  isRecap = false,
}) => {
  const { currentTheme } = AppTheme.useTheme();
  const [isChecked, setIsChecked] = React.useState(isTicked);

  const getDisplayName = () => {
    return u?.name || u?.label || "Unnamed resource";
  };

  const getDisplayDescription = () => {
    return u?.description || u?.interpolationString?.substring(0, 80) + "..." || "";
  };

  const getTypeIcon = () => {
    const name = getDisplayName().toLowerCase();
    if (name.includes("search")) return "🔍";
    if (name.includes("list") || name.includes("browse")) return "📁";
    if (name.includes("get") || name.includes("read")) return "📄";
    if (name.includes("metadata")) return "📊";
    if (name.includes("site")) return "🌐";
    if (name.includes("prompt")) return "💬";
    return "⚙️";
  };

  return (
    <View
      style={{
        flexDirection: "column",
        alignItems: "flex-start",
        marginHorizontal: 10,
        gap: 4,
        marginBottom: 12,
        padding: 10,
        backgroundColor: isRecap
          ? `${currentTheme?.theme?.softBackgroundColor}`
          : isChecked
          ? `${currentTheme?.theme?.softBackgroundColor}`
          : currentTheme?.theme?.backgroundColor,
        borderRadius: 6,
        borderWidth: 1,
        borderColor: isRecap
          ? currentTheme?.theme?.primary
          : isChecked
          ? `${currentTheme?.theme?.primary}40`
          : currentTheme?.theme?.border_color,
      }}
    >
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            flex: 1,
          }}
        >
          {!isRecap && (
            <TouchableOpacity
              onPress={() => {
                const _v = !isChecked;
                setIsChecked(_v);
                onTick(_v);
              }}
              style={{
                marginRight: 10,
                padding: 4,
              }}
            >
              <View
                style={{
                  width: 18,
                  height: 18,
                  borderRadius: 4,
                  borderWidth: 2,
                  borderColor: isChecked
                    ? currentTheme?.theme?.primary
                    : currentTheme?.theme?.border_color,
                  backgroundColor: isChecked
                    ? currentTheme?.theme?.primary
                    : "transparent",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {isChecked && (
                  <AppText
                    preventTranslation
                    style={{
                      fontSize: 12,
                      fontWeight: "bold",
                      color: currentTheme?.theme?.white,
                    }}
                  >
                    ✓
                  </AppText>
                )}
              </View>
            </TouchableOpacity>
          )}

          <View style={{ flex: 1 }}>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              {isRecap && (
                <AppText
                  preventTranslation
                  style={{ fontSize: 14, marginRight: 4 }}
                  color={
                    isChecked || isRecap
                      ? currentTheme?.theme?.font_color
                      : currentTheme?.theme?.secondary_font_color
                  }
                >
                  {getTypeIcon()}
                </AppText>
              )}
              <AppText
                preventTranslation
                style={{
                  fontWeight: isChecked || isRecap ? "600" : "400",
                  fontSize: 13,
                }}
                color={
                  isChecked || isRecap
                    ? currentTheme?.theme?.font_color
                    : currentTheme?.theme?.secondary_font_color
                }
              >
                {getDisplayName()}
              </AppText>

              {isRecap && (
                <View
                  style={{
                    marginLeft: 8,
                    paddingHorizontal: 6,
                    paddingVertical: 2,
                    backgroundColor: `${currentTheme?.theme?.softBackgroundColor}`,
                    borderRadius: 4,
                  }}
                >
                  <AppText
                    preventTranslation
                    style={{
                      fontSize: 10,
                      fontWeight: "600",
                    }}
                    color={currentTheme?.theme?.primary}
                  >
                    Ready to import
                  </AppText>
                </View>
              )}
            </View>

            {!isRecap && (
              <AppText
                preventTranslation
                style={{
                  fontSize: 11,
                  marginTop: 2,
                  marginLeft: 0,
                  lineHeight: 16,
                }}
                color={
                  isChecked
                    ? currentTheme?.theme?.secondary_font_color
                    : currentTheme?.theme?.darkGrey
                }
              >
                {getDisplayDescription()}
              </AppText>
            )}
          </View>
        </View>

        {!isRecap && !isChecked && (
          <AppText
            preventTranslation
            style={{
              fontSize: 10,
              fontStyle: "italic",
            }}
            color={currentTheme?.theme?.orange}
          >
            Excluded
          </AppText>
        )}
      </View>
    </View>
  );
};

export default QaHiringResourcesInstancesLeaf;
